import React, { lazy } from 'react'
import { Switch, Route } from 'react-router-dom'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { LazyRoute } from 'Modules'
import {
	AccessLazyRoute,
	ArticleCreateContainerLazy,
	ArticleEditContainerLazy,
	ArticlePreviewContainerLazy,
	ArticlesSearchContainerLazy,
	ArticleViewContainerLazy,
	ProjectCreateContainerLazy,
	ProjectEditContainerLazy,
	ProjectViewContainerLazy,
	VideoEditComponentLazy,
} from 'Pages/knowledge'

const KnowledgeConnectedLazy = lazy(() => import('Pages/knowledge/common/containers/Knowledge'))

export const KnowledgesRoutes: React.FC = (): JSX.Element => (
	<Switch>
		<LazyRoute
			exact
			path={FrontUrls.knowledge.index}
			lazyComponent={KnowledgeConnectedLazy}
			key={FrontUrls.knowledge.index}
		/>
		<Route exact path={FrontUrls.knowledge.admin_access} component={AccessLazyRoute} />
		<LazyRoute
			exact
			path={FrontUrls.knowledge.article_create}
			lazyComponent={ArticleCreateContainerLazy}
			key={FrontUrls.knowledge.article_create}
		/>
		<LazyRoute
			exact
			path={FrontUrls.knowledge.article_search}
			lazyComponent={ArticlesSearchContainerLazy}
			key={FrontUrls.knowledge.article_search}
		/>
		<LazyRoute
			exact
			path={FrontUrls.knowledge.article_project_create}
			lazyComponent={ArticleCreateContainerLazy}
			key={FrontUrls.knowledge.article_project_create}
		/>
		<LazyRoute
			// exact
			path={FrontUrls.knowledge.article_edit}
			lazyComponent={ArticleEditContainerLazy}
			key={FrontUrls.knowledge.article_edit}
		/>
		<LazyRoute
			exact
			path={FrontUrls.knowledge.article_preview}
			lazyComponent={ArticlePreviewContainerLazy}
			key={FrontUrls.knowledge.article_preview}
		/>
		<LazyRoute
			exact
			path={FrontUrls.knowledge.video_create}
			lazyComponent={VideoEditComponentLazy}
			key={FrontUrls.knowledge.video_create}
		/>
		<LazyRoute
			// exact
			path={FrontUrls.knowledge.video_edit}
			lazyComponent={VideoEditComponentLazy}
			key={FrontUrls.knowledge.video_edit}
		/>
		<LazyRoute
			exact
			path={FrontUrls.knowledge.project_create}
			lazyComponent={ProjectCreateContainerLazy}
			key={FrontUrls.knowledge.project_create}
		/>
		<LazyRoute
			exact
			path={FrontUrls.knowledge.project_view}
			lazyComponent={ProjectViewContainerLazy}
			key={FrontUrls.knowledge.project_view}
		/>
		<LazyRoute
			exact
			path={FrontUrls.knowledge.project_edit}
			lazyComponent={ProjectEditContainerLazy}
			key={FrontUrls.knowledge.project_edit}
		/>
		<LazyRoute
			exact
			path={FrontUrls.knowledge.article_view}
			lazyComponent={ArticleViewContainerLazy}
			key={FrontUrls.knowledge.article_view}
		/>
	</Switch>
)
